import holdingService from '../services/holding.service'
import { getParamsFilters } from './queryhelper'

export async function validateHoldingDontExist( ede )
{
    const controller = new AbortController()
    const params = getParamsFilters({edeNumber : ede})
    const res = await holdingService.getFilteredHoldings(1 , params , controller)
    return res['hydra:totalItems'] === 0 
}